/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.DOMHandler"/>
define("SuiteCommerce.Blog.ExtCarousel.DOMHandler", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Direction;
    (function (Direction) {
        Direction["right"] = "right";
        Direction["left"] = "left";
    })(Direction = exports.Direction || (exports.Direction = {}));
    var ClassNames;
    (function (ClassNames) {
        ClassNames["slidesContainer"] = "sc-ext-carousel-slides";
        ClassNames["slideWrapper"] = "sc-ext-carousel-slide";
        ClassNames["activeSlide"] = "active";
        ClassNames["incomingHelper"] = "in-{direction}";
        ClassNames["dragAreaHelper"] = "drag-area";
        ClassNames["dragStartHelper"] = "drag-start";
        ClassNames["dragEndHelper"] = "drag-end";
    })(ClassNames = exports.ClassNames || (exports.ClassNames = {}));
    exports.transitionSpeed = 400;
    exports.transitionSpeedDragging = 200;
    var ExtCarouselDOMHandler = /** @class */ (function () {
        function ExtCarouselDOMHandler(options) {
            this.transitionDelay = exports.transitionSpeed + 100;
            this.$parentElement = options.sourceView.$el;
        }
        ExtCarouselDOMHandler.prototype.executeSlideTransition = function (transition) {
            this.handleIncomingTransition(transition.target);
            this.handleOutgoingTransition(transition.current);
        };
        ExtCarouselDOMHandler.prototype.handleIncomingTransition = function (movementData) {
            var _this = this;
            this.isRunningTransition = true;
            this.toggleSelectorOnSlide(movementData.index, ClassNames.incomingHelper.replace('{direction}', movementData.direction));
            this.forceReflowSlide(movementData.index);
            this.toggleSelectorOnSlide(movementData.index, this.getOutputDirection(movementData));
            setTimeout(function () {
                _this.toggleSelectorOnSlide(movementData.index, ClassNames.activeSlide + "\n        " + ClassNames.incomingHelper.replace('{direction}', movementData.direction) + "\n        " + _this.getOutputDirection(movementData));
            }, 0);
        };
        ExtCarouselDOMHandler.prototype.handleOutgoingTransition = function (movementData) {
            var _this = this;
            this.toggleSelectorOnSlide(movementData.index, movementData.direction);
            setTimeout(function () {
                _this.toggleSelectorOnSlide(movementData.index, movementData.direction + " " + ClassNames.activeSlide);
                _this.isRunningTransition = false;
            }, exports.transitionSpeed);
        };
        ExtCarouselDOMHandler.prototype.prepareDragArea = function (current, target) {
            this.dragArea.addClass(ClassNames.dragAreaHelper);
            this.getSlideByIndex(current).addClass(ClassNames.dragStartHelper);
            this.getSlideByIndex(target).addClass(ClassNames.dragStartHelper);
        };
        ExtCarouselDOMHandler.prototype.prepareEndingDrag = function (current, target) {
            this.getSlideByIndex(current).addClass(ClassNames.dragEndHelper);
            this.getSlideByIndex(target).addClass(ClassNames.dragEndHelper);
        };
        ExtCarouselDOMHandler.prototype.moveSlideTo = function (movementData) {
            this.getSlideByIndex(movementData.index).css('transform', "translateX(" + movementData.vectorX + "px)");
        };
        ExtCarouselDOMHandler.prototype.getVectorXForBoundSlide = function (dragDirection, activeSlideIndex) {
            if (!this.$lastActiveSlide || activeSlideIndex !== this.lastActiveSlideIndex) {
                this.updateLastActiveSlide(activeSlideIndex);
            }
            var offset = this.$lastActiveSlide.offset();
            var activeSlideOffset = (offset) ? offset.left : 0;
            if (dragDirection === Direction.right) {
                return activeSlideOffset + this.lastActiveSlideWidth - this.lastActiveSlideOffsetParent;
            }
            return this.lastActiveSlideWidth - activeSlideOffset + this.lastActiveSlideOffsetParent;
        };
        ExtCarouselDOMHandler.prototype.updateLastActiveSlide = function (index) {
            this.lastActiveSlideIndex = index;
            this.$lastActiveSlide = this.getSlideByIndex(index);
            this.lastActiveSlideWidth = this.$lastActiveSlide.width();
            var parent = this.$lastActiveSlide.offsetParent();
            var parentOffset = (parent) ? parent.offset() : null;
            this.lastActiveSlideOffsetParent = (parentOffset) ? parentOffset.left : 0;
        };
        ExtCarouselDOMHandler.prototype.getOutputDirection = function (movement) {
            return movement.direction === Direction.left ? Direction.right : Direction.left;
        };
        ExtCarouselDOMHandler.prototype.cleanDragUtilities = function (activeSlideIndex, targetSlideIndex) {
            this.cleanDragUtilitiesForSlide(activeSlideIndex);
            this.cleanDragUtilitiesForSlide(targetSlideIndex);
            this.dragArea.removeClass(ClassNames.dragAreaHelper);
        };
        ExtCarouselDOMHandler.prototype.cleanDragUtilitiesForSlide = function (index) {
            var $slide = this.getSlideByIndex(index);
            $slide.removeClass(ClassNames.dragStartHelper + " " + ClassNames.dragEndHelper);
            $slide.removeAttr('style');
        };
        ExtCarouselDOMHandler.prototype.toggleSelectorOnSlide = function (index, selector) {
            var slide = this.getSlideByIndex(index);
            slide.toggleClass(selector);
        };
        ExtCarouselDOMHandler.prototype.getSlideByIndex = function (index) {
            return this.slides.eq(index);
        };
        Object.defineProperty(ExtCarouselDOMHandler.prototype, "slides", {
            get: function () {
                if (!this.$slides)
                    this.$slides = this.$parentElement.find(this.formatAsSelector(ClassNames.slideWrapper));
                return this.$slides;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ExtCarouselDOMHandler.prototype, "dragArea", {
            get: function () {
                if (!this.$dragArea) {
                    this.$dragArea = this.$parentElement.find(this.formatAsSelector(ClassNames.slidesContainer));
                }
                return this.$dragArea;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ExtCarouselDOMHandler.prototype, "screenWidth", {
            get: function () {
                return jQuery(window).width();
            },
            enumerable: true,
            configurable: true
        });
        ExtCarouselDOMHandler.prototype.formatAsSelector = function (text) {
            return "." + text;
        };
        ExtCarouselDOMHandler.prototype.forceReflowSlide = function (index) {
            var $slide = this.getSlideByIndex(index);
            var offset = $slide.offset();
            if (offset) {
                offset.top;
                offset.left;
            }
        };
        return ExtCarouselDOMHandler;
    }());
    exports.ExtCarouselDOMHandler = ExtCarouselDOMHandler;
});
